<template>
  <div class="signup">
    <div class="title">
      请输入试用信息
    </div>
    <van-form @submit="onSubmit" ref="vanForm" label-width="4em" label-align="right">
      <van-field label="系统名称" readonly is-link class="name_field" v-model="form.systemName" placeholder="请选择试用系统"
        @click="showPopup" :rules="rules.systemName" />
      <van-field label="申请理由" class="name_field" v-model="form.reason" placeholder="请输入申请理由" :rules="rules.reason" />
      <van-field label="上传附件 " class="name_field" v-model="form.file">
        <template #input>
          <div class="upload_wrap">
            <van-uploader :after-read="afterRead" :before-read="beforeRead" accept=".docx">
              <van-button class="upload_btn">上传文件</van-button>
            </van-uploader>
            <van-button class="upload_btn" @click.stop.prevent="downloadTemplate">下载模版</van-button>
          </div>
        </template>
      </van-field>
      <div class="btn_wrap">
        <van-button block type="info" :disabled="btnLoading" :loading="loading" class="btn"
          native-type="submit">提交申请</van-button>
      </div>
    </van-form>
    <van-popup position="bottom" v-model="show">
      <van-picker show-toolbar title="标题" :columns="columns" @cancel="onCancel" @confirm="onConfirm" value-key="name" />
    </van-popup>
  </div>
</template>
<script>
import imageUpload from '@/components/imageUpload'
import { getSystemList, applyTrial, downLoadTemplate, uploadAttachment } from '@/api/index'
import { Toast } from 'vant';

export default {
  name: 'Signup',
  components: {
    imageUpload
  },
  data() {
    return {
      form: {
      },
      columns: [],
      show: false,
      timeShow: false,
      rules: {
        systemName: [
          { required: true, message: '请选择试用系统' },
        ],
        reason: [
          { required: true, message: '请输入申请理由', trigger: 'onBlur' },
        ],
        file: [
          { required: true, message: '请上传附件' },
        ],
      },
      loading: false,
      btnLoading: false,
    }
  },
  mounted() {
    this.getSystem()
  },
  methods: {
    getSystem() {
      getSystemList().then(res => {
        this.columns = res
      })
    },
    onSubmit() {
      // 校验表单
      this.$refs.vanForm.validate().then(() => {
        if (!this.form.file) {
          return Toast('请上传附件！');
        }
        let data = {
          systemName: this.form.systemName,
          reason: this.form.reason,
          file: this.form.file,
          systemId: this.columns.find(item => item.name === this.form.systemName).id
        }
        applyTrial(data).then(res => {
          console.log(res);
          Toast('提交成功！');
          this.form = {};
          this.loading = false;
        })
      }).catch((error) => { });
    },
    showPopup() {
      this.show = true;
    },
    onCancel() {
      this.show = false;
    },
    onConfirm(val) {
      this.form.systemName = val.name;
      this.show = false;
    },
    downLoad() {
      downLoadTemplate().then(res => {
        const blob = new Blob([res]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'template.docx'; // Specify the file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
    },
    downloadTemplate() {
      // 使用相对路径
      const fileUrl = '/123.docx';

      // 创建一个隐藏的a标签
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'template.docx';  // 设置下载文件名

      // 将a标签添加到DOM并触发点击事件
      document.body.appendChild(link);
      link.click();

      // 移除a标签
      document.body.removeChild(link);
    },
    //  上传之前要做的校验
    beforeRead(files) {
      if (!files.name.endsWith('.docx')) {
        Toast('请上传.docx格式的文件！');
        return false;
      }
      return true;
    },
    // 上传文件请求
    afterRead(files) {
      files.status = "uploading";
      files.message = "上传中...";
      const formData = new FormData();
      formData.append("file", files.file);
      uploadAttachment(formData)
        .then(res => {
          files.status = "done";
          console.log(res);
          Toast('上传成功！');
          this.form.file = res
        })
        .catch(err => {
          console.log(err);
          files.status = "failed";
          files.message = "上传失败";
        });
    }
  },
}
</script>
<style scoped lang="less">
.signup {
  width: 80%;
  padding: 20px;
  margin: 0 auto;
  background-color: #fff;

  .title {
    margin: 20px 0;
    font-size: 0.16rem;
    font-weight: bold;
    text-align: center;

  }

  .name_field {
    margin-bottom: 10px;
  }

  .btn {
    background-color: rgba(43, 70, 138, 1);
    color: #fff;
    font-size: 0.14rem;
    text-align: center;
    font-family: Roboto;
    border-radius: 8px;
  }

  .upload_btn {
    background-color: rgba(43, 70, 138, 1);
    color: #fff;
    font-size: 0.14rem;
    text-align: center;
    font-family: Roboto;
    border-radius: 8px;
    width: 70px;
    height: 30px;
    padding: 5px 0;
  }

}

.upload_wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>